import React from 'react'
import PropTypes from 'prop-types'

import ModalWizard from 'components/modal_wizard'
import { routerShape } from 'react-router/lib/PropTypes'
import { withRouter } from 'react-router'
import Confetti from 'components/common/confetti'
import { trackClick } from 'lib/fpti_analytics'

import { exitGlimpse, isForward } from 'lib/glimpse'

class EditGlimpse extends React.Component {
  static propTypes = {
    operatingRemotely: PropTypes.bool,
    children: PropTypes.any,
    routes: PropTypes.array.isRequired,
    params: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    router: routerShape.isRequired,
    route: PropTypes.any,
    progressValue: PropTypes.number,
    goalReached: PropTypes.bool,
    charity: PropTypes.object,
  }

  handleClose = () => {
    const charity = this.props.charity
    exitGlimpse('edit', this.props.router)
    trackClick({
      clickName: 'dw_giving_manage_fundraiser_dismiss_pressed',
      data: {
        event_name: 'dw_giving_manage_fundraiser_dismiss_pressed',
        dismiss_method: 'close',
        flow:
          charity && charity.name
            ? 'GENEROSITY_NETWORK_CHARITIES'
            : 'GENEROSITY_NETWORK',
        charityname: charity && charity.name,
        crid: charity && charity.nonprofit_id,
      },
    })
  }

  render() {
    const child = React.Children.only(this.props.children)
    const stepName = this.props.routes[this.props.routes.length - 1].path
    const isDelete = stepName === 'delete'
    return (
      <ModalWizard
        movingForward={isForward(this.props.location)}
        hideBack={this.props.params.hideBack}
        glimpse={true}
        showSpinner={!isDelete && this.props.operatingRemotely}
        onClose={this.handleClose}
        background={
          stepName === 'manage' && this.props.goalReached ? Confetti : undefined
        }
        route={this.props.route}
      >
        {React.cloneElement(child, { key: stepName })}
      </ModalWizard>
    )
  }
}

export default withRouter(EditGlimpse)
